import React, { Component } from "react";
import Home from "./presenter";

class Container extends Component {
  render() {
    return <Home {...this.props} />;
  }
}

export default Container;
